import VimeoPlayer from "@vimeo/player";

declare global {
	interface Window {
		Vimeo: VimeoType;
	}
}

export type VimeoType = {
	Player: new (element: HTMLIFrameElement) => VimeoPlayer;
};

class VimeoService {
	loaded: boolean = false;
	#items: {
		iframe: HTMLIFrameElement;
		promise: Promise<VimeoPlayer>;
		resolve: (value: VimeoPlayer) => void;
	}[] = [];

	register = (iframe: HTMLIFrameElement): Promise<VimeoPlayer> => {
		const item = this.#items.find((item) => item.iframe === iframe);

		if (this.#items.length === 0) {
			this.#initVimeoAPI();
		}

		if (item) {
			return item.promise;
		}

		let promiseResolve: (value: VimeoPlayer) => void;
		const promise = new Promise<VimeoPlayer>((resolve) => {
			promiseResolve = resolve;
			if (this.loaded && window.Vimeo) {
				resolve(new window.Vimeo.Player(iframe));
			}
		});

		this.#items.push({
			iframe: iframe,
			promise: promise,
			resolve: promiseResolve,
		});

		return promise;
	};

	#initVimeoAPI = (): void => {
		const scriptTag = document.createElement("script");
		scriptTag.src = "https://player.vimeo.com/api/player.js";
		document.head.append(scriptTag);

		scriptTag.addEventListener("load", () => {
			this.loaded = true;

			this.#items.forEach(({ iframe, resolve }) => {
				resolve(new window.Vimeo.Player(iframe));
			});
		});
	};
}

export const vimeoService = new VimeoService();
